import { render, staticRenderFns } from "./goods-evaluation.vue?vue&type=template&id=4fb52b5b&scoped=true&"
import script from "./goods-evaluation.vue?vue&type=script&lang=js&"
export * from "./goods-evaluation.vue?vue&type=script&lang=js&"
import style0 from "./goods-evaluation.vue?vue&type=style&index=0&id=4fb52b5b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb52b5b",
  null
  
)

export default component.exports